import { create } from "zustand";
import { type TFormatDateLocale } from "@utils/units";

interface Ii18nStoreProps {
  locale: TFormatDateLocale;
  /**
   * SET LOCALE WON"T CHANGE THE LANGUAGE OF THE APP, THIS IS USED TO GLOBALLY STORE THE LOCALE
   */
  setLocale: (locale: TFormatDateLocale) => void;
}

export const useI18nStore = create<Ii18nStoreProps>((set) => ({
  locale: "lt",
  setLocale: (locale) => set({ locale }),
}));
